import React from 'react'
import Dashboard from '../../Layout/Dashboard'

const DashBoardPage = () => {
  return <Dashboard />
}

export default DashBoardPage
